import React from 'react'

import MyhouseRegisterLayout from '@Pages/myhouseRegister/layout'
import { ReactLazyPreload } from '@Components/utils/RouterUtils'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'

const MyhouseRegisterMainPage = ReactLazyPreload(() => import(/* webpackChunkName: 'MyhouseRegisterMainPage' */ './register/main'))

const MyhouseRegisterAddressPage = ReactLazyPreload(() => import(/* webpackChunkName: 'MyhouseRegisterAddressPage' */ './register/address'))

const MyhouseRegisterPyeongPage = ReactLazyPreload(() => import(/* webpackChunkName: 'MyhouseRegisterPyeongPage' */ './register/pyeong'))

const MyhouseRegisterResultPage = ReactLazyPreload(() => import(/* webpackChunkName: 'MyhouseRegisterResultPage' */ './register/result'))

export default {
  layout: MyhouseRegisterLayout,
  routes: [
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/main`, `${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/main/:myhouseNo`],
      exact: true,
      component: MyhouseRegisterMainPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/address`, `${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/address/:myhouseNo`],
      exact: true,
      component: MyhouseRegisterAddressPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/pyeong`, `${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/pyeong/:myhouseNo`],
      exact: true,
      component: MyhouseRegisterPyeongPage,
    },
    {
      path: [`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/result/:myhouseNo`],
      exact: true,
      component: MyhouseRegisterResultPage,
    },
  ],
}
